export default "__VITE_ASSET__6dc07d0c__"